import React, { useState } from 'react'
import { Box, Grid, makeStyles } from '@material-ui/core'
import newBornSelectedImage from 'src/assets/AddedServices/Marriage/newBornSelected.svg'
import marraigeImage from 'src/assets/AddedServices/Marriage/marriage.svg'
import marrigeSelectedImage from 'src/assets/AddedServices/Marriage/marrigeSelected.svg'
import newBornImage from 'src/assets/AddedServices/Marriage/newBorn.svg'
import Marriage from 'src/components/Individual/AddedServices/Marriage'
import NewBorn from 'src/components/Individual/AddedServices/NewBorn'
import { tabTypes } from 'src/utils/constants/Individual'

const MarriageOrNewBorn = () => {
  const classes = useStyles()

  const [tabType, setTabType] = useState(tabTypes?.MARRIAGE)
  const [isMarriage, setIsMarriage] = useState(true)

  const getTabComponent = (tabName) => {
    switch (tabName) {
      case tabTypes?.MARRIAGE:
        return <Marriage />
      case tabTypes?.NEW_BORN:
        return <NewBorn />
      default:
        return <></>
    }
  }

  const updateMarriage = () => {
    setTabType(tabTypes?.MARRIAGE)
    setIsMarriage(true)
  }

  const updateNewBorn = () => {
    setTabType(tabTypes?.NEW_BORN)
    setIsMarriage(false)
  }

  return (
    <Grid container spacing={5} className={classes.gridContainer}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Box
              onClick={updateMarriage}
              className={classes.isMarrageContainer}
            >
              {isMarriage ? (
                <img
                  src={marrigeSelectedImage}
                  alt='marrigeSelectedImage'
                  className={classes.coupleImage}
                />
              ) : (
                <img
                  src={marraigeImage}
                  alt='marriageImage'
                  className={classes.coupleImage}
                />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Box onClick={updateNewBorn} className={classes.isMarrageContainer}>
              {isMarriage ? (
                <img
                  src={newBornImage}
                  alt='newBornImage'
                  className={classes.coupleImage}
                />
              ) : (
                <img
                  src={newBornSelectedImage}
                  alt='newBornSelectedImage'
                  className={classes.coupleImage}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Box>{getTabComponent(tabType)}</Box>
      </Grid>
    </Grid>
  )
}
export default MarriageOrNewBorn
const useStyles = makeStyles((theme) => ({
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    animation: `$slideEffect 1000ms ${theme.transitions.easing.easeInOut}`,
  },

  '@keyframes slideEffect': {
    '0%': {
      opacity: 0,
      transform: 'translate(100%, 100% , 100%)',
    },
    '100%': {
      opacity: 1,
      transform: 'translate(-50%,-50%,-50%)',
    },
  },
  isMarrageContainer: {
    width: '100%',
    cursor: 'pointer',
  },
  coupleImage: { width: '100%' },
}))
